import { render, staticRenderFns } from "./FavoriteBottleListItem.vue?vue&type=template&id=46a9df1e&"
import script from "./FavoriteBottleListItem.vue?vue&type=script&lang=js&"
export * from "./FavoriteBottleListItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports